function getErrorMessage(error: unknown): string {
  if (error instanceof Error) {
    return error.message;
  }
  if (typeof error === "string") {
    return error;
  }
  return "";
}

export const PORTAL_KEY_ALREADY_EXISTS_MESSAGE =
  "This portal key already exists. Please enter a unique portal key.";

export const PURCHASER_PORTAL_KEY_SAVE_NETWORK_ERROR_MESSAGE =
  "Failed to save portal key. Please try again later.";

export const PURCHASER_PORTAL_KEY_LOAD_NETWORK_ERROR_MESSAGE =
  "Failed to load portal keys. Please try again later.";

function isNetworkError(error: unknown): boolean {
  const normalized = getErrorMessage(error).toLowerCase();
  if (
    normalized.includes("failed to fetch") ||
    normalized.includes("network error") ||
    normalized.includes("networkerror") ||
    normalized.includes("load failed") ||
    normalized.includes("network request failed")
  ) {
    return true;
  }
  return (
    error != null &&
    typeof error === "object" &&
    "networkError" in error &&
    (error as { networkError?: unknown }).networkError != null
  );
}

export function getPurchaserPortalKeyFieldError(error: unknown): string | null {
  const normalized = getErrorMessage(error).toLowerCase();
  if (
    normalized.includes("duplicate") ||
    normalized.includes("already exists")
  ) {
    return PORTAL_KEY_ALREADY_EXISTS_MESSAGE;
  }
  return null;
}

export function getPurchaserPortalKeySaveErrorMessage(error: unknown): string {
  if (isNetworkError(error)) {
    return PURCHASER_PORTAL_KEY_SAVE_NETWORK_ERROR_MESSAGE;
  }
  if (error instanceof Error && error.message.trim()) {
    return error.message;
  }
  return "Failed to save portal key";
}

export function getPurchaserPortalKeyLoadErrorMessage(error: unknown): string {
  if (isNetworkError(error)) {
    return PURCHASER_PORTAL_KEY_LOAD_NETWORK_ERROR_MESSAGE;
  }
  if (error instanceof Error && error.message.trim()) {
    return error.message;
  }
  return "Failed to load portal keys";
}
